/* eslint-disable max-len */
import axios from 'axios';
import { getConfig } from '../config';

export const getPlaConfigurationDetails = async (plaGuid, baseConfigurationIdForSelections, omsId, regionId, surfaceCodes) => {
  const customBaseUrl = getConfig()?.customBaseUrl;

  const url = `${customBaseUrl}/countertops/api/pla/${plaGuid}?preconfigGuid=${baseConfigurationIdForSelections}&omsid=${omsId}&regionId=${regionId}&surfaceCodes=${surfaceCodes}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }

};

export const getNewPlaConfiguredPrice = async (apiPayload) => {
  const eleanorBaseUrl = getConfig()?.eleanorBaseUrl;

  const url = `${eleanorBaseUrl}/api/pricing/configurator/basetableschoicepricing`;

  const params = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  try {
    const response = await axios.post(url, apiPayload, { headers: params });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
